import { FormControl, TextField } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& .MuiInputBase-input": {
        fontSize: '1.4rem',
      },
      "& .MuiInputLabel-outlined": {
        transform: 'translate(14px, 18px) scale(1)'
      },
      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(0.75)"
      },
      "& .MuiInputBase-root": {
        fontSize: "1.4rem",
        innerHeight: 'inherit',
      },
      "& .MuiInputLabel-root": {
        textAlign: 'center',
        fontSize: "1.4rem",
      },
      "& .MuiOutlinedInput-input": {
        padding: '16px 14px'
      },
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        fontSize: "1.4rem",
      },
      "& .MuiFormHelperText-root": {
        fontSize: "1.2rem",
      },
    }
  }));

type SelectFieldTypes = {
  value?: string | number,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  onBlur?: () => void,
  variant?: 'outlined' | 'filled' | 'standard',
  id?: string,
  label: string,
  error?: any,
  helperText?: string | false | undefined,
  name: string,
  fullWidth?: boolean,
  required?: boolean,
  type?: string | undefined,
  textTransform?: 'uppercase' | 'lowercase' | 'capitalize' | 'inherit',
  disabled?: boolean
}

export const Input = ({
  value, onChange, onBlur, variant = 'standard',
  id, label, error, helperText,
  name, fullWidth = false, required = false, disabled,
  type = 'text', textTransform = 'capitalize', ...rest }: SelectFieldTypes) => {
  const classes = useStyles();

  return (
    <FormControl variant={variant} fullWidth={fullWidth}>
      <TextField
        type={type}
        className={classes.root}
        id={id}
        name={name}
        label={label}
        value={value}
        error={error}
        autoComplete="off"
        helperText={helperText}
        onChange={onChange}
        onBlur={onBlur}
        variant={variant}
        required={required}
        inputProps={
          {
            autoComplete: 'off',
            form: {
              autoComplete: 'off'
            },
            style: { textTransform: textTransform }
          }}
        disabled={disabled}
      />
    </FormControl>
  )
}